<template>
  <vs-row id="totalOrderLogs" vs-type="flex" vs-w="12" vs-justify="space-between">
    <printer ref="printer" :sumOfOrders="sumOfOrders" :sumOfExpenses="sumOfExpenses" :getTotalPrice="getTotalPrice"
      :getTotalExpensePrice="getTotalExpensePrice" :reportDate="reportDate" />
    <vs-row vs-type="flex" vs-w="12" class="pb-1">
      <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="center">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" class="w-auto">
            <vx-tooltip text="Detaylı Filtereleme" position="top">
              <vs-button @click="isFiltererOpen = !isFiltererOpen"
                class="panel-action text-success xlarge-button panel-action-box-shadow" color="transparent"
                icon-pack="pickicon" icon="icon-pick-filter">
              </vs-button>
            </vx-tooltip>
          </vs-col>
          <vs-col vs-type="flex" class="w-auto">
            <vx-tooltip text="Yazdır" position="top">
              <vs-button @click="printTable" class="panel-action text-warning xlarge-button panel-action-box-shadow"
                color="transparent" icon-pack="feather" icon="icon-printer" />
            </vx-tooltip>
          </vs-col>
          <vs-col vs-type="flex" class="w-auto">
            <vx-tooltip text="Excel Export" position="top">
              <vs-button @click="getExcel" class="panel-action text-warning xlarge-button panel-action-box-shadow"
                color="transparent" icon-pack="feather" icon="icon-download" />
            </vx-tooltip>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="mt-1" vs-justify="space-between">
      <vs-col v-if="isFiltererOpen" vs-type="block" vs-w="3.75" vs-sm="12" class="mb-1" vs-align="center"
        vs-justify="center">
        <vs-row vs-type="flex" vs-w="12" vs-sm="12">
          <vs-row vs-type="flex" vs-w="12" vs-align="center">
            <vs-col vs-type="flex" vs-w="6" class="pr-1">
              <datepicker :highlighted="highlightedFn" class="w-full bg-white" :language="turkish" format="d MMMM yyyy"
                v-model="filterOptions.dateRange.startDate"></datepicker>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6">
              <vue-timepicker class="w-full bg-white orderLogTimeFilter" :language="turkish" placeholder="Başlangıç Saati"
                v-model="filterOptions.timeRange.startTime"></vue-timepicker>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" vs-sm="12" class="mt-2" vs-align="center">
            <vs-col vs-type="flex" vs-w="6" class="pr-1">
              <datepicker :highlighted="highlightedFn" class="w-full bg-white" :language="turkish" format="d MMMM yyyy"
                v-model="filterOptions.dateRange.endDate"></datepicker>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6">
              <vue-timepicker class="w-full bg-white orderLogTimeFilter" :language="turkish" placeholder="Bitiş Saati"
                v-model="filterOptions.timeRange.endTime"></vue-timepicker>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-2">
            <v-select v-if="$currentUser.branch.id == 1 || this.$isRegionalCenterBranch()" v-model="filterOptions.branchId" :reduce="x=> x.id" itemid="id"
              label="name" placeholder="Şube Seçimi" :options="branches" class="w-full bg-white" :clearable="true">
            </v-select>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-2" vs-justify="space-between">
            <vs-button type="gradient" color="danger" @click="clearFilterOptions">
              Sil
            </vs-button>
            <vs-button color="success" @click="saveFilterOptions">Sorgula</vs-button>
          </vs-row>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" :vs-w="isFiltererOpen ? 8 : 12" vs-sm="12">
        <vs-row vs-type="block" vs-w="12">
          <vs-row vs-type="block" style="height:fit-content;" vs-w="12">
            <vs-table id="totalOrderLogTable" ref="table" :data="sumOfOrders" class="w-full">
              <template slot="thead">

                <vs-th class="w-5/12">
                  <p class="text-primary">Ödeme</p>
                </vs-th>
                <vs-th class="w-3/12">
                  <p class="text-primary">Adet</p>
                </vs-th>
                <vs-th class="w-4/12">
                  <p class="text-primary">Tutar</p>
                </vs-th>
              </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                    :class="{'row-bg-danger' : tr.effect == 'Negatif', 'row-bg-warning' : tr.effect == 'Nötr'}">

                    <vs-td class="w-5/12">
                      <span class="text-center weight-600">{{ tr.paymentName }}</span>
                    </vs-td>

                    <vs-td class="w-3/12">
                      <span class="text-center weight-600">{{ tr.totalCount }}</span>
                    </vs-td>

                    <vs-td class="w-4/12">
                      <span class="text-center weight-600">{{ $toCurrency(tr.totalPrice) }}</span>
                    </vs-td>
                  </vs-tr>
                  <vs-tr v-if="sumOfExpenses.length > 0" class="row-bg-danger">
                    <vs-td class="w-6/12">
                      <span class="text-center weight-600">Gider</span>
                    </vs-td>
                    <vs-td class="w-3/12">
                      <span class="text-center weight-600">{{sumOfExpenses.length}}</span>
                    </vs-td>
                    <vs-td class="w-3/12">
                      <span class="text-center weight-600">{{$toCurrency(getTotalExpensePrice)}}</span>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-2 mb-4 px-2 bg-white py-1 border-all border-success"
            vs-justify="space-between">
            <vs-col vs-type="flex" vs-w="6" vs-justify="center" vs-align="center" class="border-bottom py-1">
              <span class="text-small weight-600">Toplam Ciro</span>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" vs-justify="center" vs-align="center" class="border-bottom py-1">
              <span class="h4 text-dark bold">{{$toCurrency(getTotalPrice)}}</span>
            </vs-col>
            <vs-col v-if="false" vs-type="flex" vs-w="6" vs-justify="center" vs-align="center"
              class="border-bottom py-1">
              <span class="text-small weight-600">Toplam Giderler</span>
            </vs-col>
            <vs-col v-if="false" vs-type="flex" vs-w="6" vs-justify="center" vs-align="center"
              class="border-bottom py-1">
              <span class="h4 text-dark bold">{{$toCurrency(getTotalExpensePrice)}}</span>
            </vs-col>
            <vs-col v-if="false" vs-type="flex" vs-w="6" vs-justify="center" vs-align="center" class="py-1">
              <span class="h4 text-primary bold">Toplam</span>
            </vs-col>
            <vs-col v-if="false" vs-type="flex" vs-w="6" vs-justify="center" vs-align="center" class="py-1">
              <span class="h4 text-primary bold">{{$toCurrency(getTotalPrice-getTotalExpensePrice)}}</span>
            </vs-col>
          </vs-row>
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import {
    tr
  } from "vuejs-datepicker/src/locale";
  import Datepicker from "vuejs-datepicker";
  import Printer from "./Printer.vue";
  import {
    getSumOfOrders,
    getSumOfOrdersForDealer,
    getExcelSumOfOrders,
    getExcelSumOfOrdersForDealer
  } from "@/api/Reports";
  import {
    getBranchNameList2
  } from "@/api/Branch";

  export default {
    components: {
      VueTimepicker,
      Datepicker,
      Printer
    },
    data() {
      return {
        branches: [],
        sumOfOrders: [],
        sumOfExpenses: [],
        highlightedFn: {
          customPredictor(date) {
            if (date.toISOString().slice(0, 10) === new Date(Date.now()).toISOString().slice(0, 10)) {
              return true;
            }
          }
        },
        isFiltererOpen: false,
        format: "dd MM yyyy ",
        turkish: tr,
        filterOptions: {},
        isPrintMode: false
      };
    },
    created: async function () {
      this.branches = await getBranchNameList2();
    },
    mounted() {
      this.clearFilterOptions();
    },
    computed: {
      reportDate() {
        var reportDate;
        if(Object.keys(this.filterOptions).length == 0) return "";
        if (this.filterOptions.dateRange.startDate == this.filterOptions.dateRange.endDate) reportDate = this.filterOptions.dateRange.startDate
          .toString();
        else reportDate = this.filterOptions.dateRange.startDate.toString() + " - " + this.filterOptions.dateRange.endDate.toString();
        return reportDate;
      },
      getTotalExpensePrice() {
        return this.sumOfExpenses.reduce(function (total, num) {
          return total + num.price;
        }, 0);
      },
      getTotalPrice() {
        return this.sumOfOrders.reduce(function (total, num) {
          return total + (num.effect == 'Pozitif' ? num.totalPrice : 0);
        }, 0);
      },
    },
    watch:{
      'filterOptions.timeRange.startTime': function (val) {
        if (!val) return;
        if(val.HH == '' && val.mm == ''){
          this.filterOptions.timeRange.startTime = null;
        }
        else if(val.HH && !val.mm){
          this.filterOptions.timeRange.startTime.mm = "00";
        }
        else if(val.mm && !val.HH){
          this.filterOptions.timeRange.startTime.HH = "00";
        }
      },
      'filterOptions.timeRange.endTime': function (val) {
        if (!val) return;
        if(val.HH == '' && val.mm == ''){
          this.filterOptions.timeRange.endTime = null;
        }
        else if(val.HH && !val.mm){
          this.filterOptions.timeRange.endTime.mm = "00";
        }
        else if(val.mm && !val.HH){
          this.filterOptions.timeRange.endTime.HH = "00";
        }
      }
    },
    methods: {
      getExcel() {
        if (this.$isRegionalCenterBranch()) {
          getExcelSumOfOrdersForDealer(this.filterOptions).then(res => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            let now = this.$now.date();
            link.setAttribute('download', 'Ciro Raporu' + now.getDate() + " " + this.$months()[now.getMonth()]
              .name + " " + now.getFullYear() + '.xlsx');
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        })
        } else {
          getExcelSumOfOrders(this.filterOptions).then(res => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            let now = this.$now.date();
            link.setAttribute('download', 'Ciro Raporu' + now.getDate() + " " + this.$months()[now.getMonth()]
              .name + " " + now.getFullYear() + '.xlsx');
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        })
        }

      },
      clearFilterOptions() {
        this.filterOptions = {
          dateRange:{
            startDate: this.$now().getHours() >= 0 && this.$now().getHours() <= 2 ? this.$preDate() : this.$now.date(),
            endDate: this.$now().getHours() >= 0 && this.$now().getHours() <= 2 ? this.$preDate() : this.$now.date(),
          },
          branchId: null,
          timeRange:{
            startTime: null,
            endTime: null
          }
        }
        this.saveFilterOptions();
      },
      saveFilterOptions() {
        if (this.$isRegionalCenterBranch()) {
          getSumOfOrdersForDealer(this.filterOptions).then(res => {
          if (res && res.status == 200) {
            this.sumOfOrders = res.data.paymentReport;
            this.sumOfExpenses = res.data.sumOfExpenses;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Rapor Hazırlanamadı !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
        } else {
          getSumOfOrders(this.filterOptions).then(res => {
          if (res && res.status == 200) {
            this.sumOfOrders = res.data.paymentReport;
            this.sumOfExpenses = res.data.sumOfExpenses;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Rapor Hazırlanamadı !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
        }

      },
      printTable() {
        if (this.$refs.printer) {
          this.$refs.printer.printTotalOrderLogs();
        }
      }
    }
  };

</script>

<style>
  #totalOrderLogTable .con-tablex .vs-con-tbody table {
    min-width: unset !important;
  }

  .row-bg-danger {
    background-color: rgba(238, 66, 75, 0.5) !important;
  }

  .row-bg-warning {
    background-color: rgba(255, 159, 67, .5) !important;
  }

  .orderLogTimeFilter input {
    padding: .7em .5em !important;
    border-radius: .4rem;
    width: 100% !important;
    height: unset !important;
  }
#totalOrderLogs .vue__time-picker .dropdown {
  z-index: 500!important;
}
</style>
